import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/admin/organizations/$organizationId/opportunities/$opportunityId/",
)({
  component: OpportunityIndex,
});

function OpportunityIndex() {
  const { organizationId, opportunityId } = Route.useParams();
  return (
    <Navigate
      to="/admin/organizations/$organizationId/opportunities/$opportunityId/requirements"
      params={{ organizationId, opportunityId }}
      replace
    />
  );
}
